import styled from 'styled-components';

export const Card = styled.article`
  background: ${({ theme }) => theme.color.light['0']};
  box-shadow: 0px 2px 5px 1px rgba(0, 0, 0, 0.3);
  padding: ${(p) => p.theme.scale(-1)};
  margin-bottom: ${(p) => p.theme.scale(0)};
`;
